import React from 'react';
import PropTypes from 'prop-types';
import ButtonHome from './ButtonHome';

function LeftSection({ content }) {
  return (
    <>
      <div className={`tab-bar-menu`}>
        <ButtonHome />
      </div>
      <div className={`tab-bar-menu`}>
        { React.cloneElement(content, {}) }
      </div>
    </>
  )
}

LeftSection.propTypes = {
  content: PropTypes.element.isRequired,
}

export default LeftSection;
